import request from './request'

// 登录
export async function login(data) {
    return request({
        url: 'api/sign_in_with_password',
        method: 'post',
        data
    })
}

//获取当前用户信息
export async function getUserPerms(data) {
    return request({
        url: "api/user_meta_info",
        method: 'get',
        data
    })
}

//发送手机验证码
export async function sendVeriCodeToPhone(data) {
    return request({
        url: "api/send_veri_code_to_phone/"+data['phone_or_email'],
        method: 'get'
    })
}
//发送邮箱验证码
export async function sendVeriCodeToEmail(data) {
    return request({
        url: "api/send_veri_code_to_email/"+data['phone_or_email'],
        method: 'get'
    })
}
// 注册
export async function signUp(data) {
    return request({
        url: 'api/sign_up',
        method: 'post',
        data
    })
}
//更新头像
export async function updateAvatar(data) {
    return request({
        url: 'api/update_avatar',
        method: 'put',
        data
    })
}
//更新用户名
export async function updateUsername(data) {
    return request({
        url: 'api/update_username',
        method: 'patch',
        data
    })
}
//更新密码
export async function updatePassword(data) {
    return request({
        url: 'api/update_password',
        method: 'patch',
        data
    })
}
//更新手机号
export async function updatePhone(data) {
    return request({
        url: 'api/update_phone_number',
        method: 'patch',
        data
    })
}
//更新邮箱
export async function updateEmail(data) {
    return request({
        url: 'api/update_email_address',
        method: 'patch',
        data
    })
}
//用户钱包信息
export async function getWalletInfo(data) {
    return request({
        url: 'api/wallet/all',
        method: 'get',
        data
    })
}
//支付-创建订单
export async function getAlipayInfo(data) {
    return request({
        url: 'api/CNY/orders/create/with/alipay/qr-code',
        method: 'post',
        data
    })
}

//支付-查询结果 /
export async function getAlipayResult(data) {
    return request({
        url: `api/CNY/orders/check_payment_status/${data['order_id']}`,
        method: 'get'
    })
}



